import {OptionStatusIndicator} from 'platform/components';

export type AssignmentOption = {
  value: string;
  label: string;
  statusIndicator?: OptionStatusIndicator;
};
